import React from "react"
import {useNavigate} from 'react-router-dom'
import {RedocStandalone} from 'redoc'
import { Button, Grid, ThemeProvider, Box, GlobalStyles } from "@mui/material"
import {AppBar} from '@mui/material'
import MoreVertButton from "../../components/more-vert-button"
import DownloadIcon from '@mui/icons-material/Download'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import theme from "../../utils/theme"
import {HOME_PAGE} from "../../utils/routes"

const ApiPage = () => {
    const navigate = useNavigate()

    const downloadFile = (filePath, fileName) => {
        const link = document.createElement("a")
        link.href = filePath
        link.download = fileName
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }

    const downloadCollection = () => {
        downloadFile("/docs/collection/c2p.postman_collection.json", "c2p.postman_collection.json")
    }

    const downloadEnvironment = () => {
        downloadFile("/docs/collection/environment.json", "environment.json")
    }

    const options = [
        {
            icon: <DownloadIcon color="primary"/>,
            text: "Download da Collection",
            function: downloadCollection
        },
        {
            icon: <DownloadIcon color="primary"/>,
            text: "Download do Arquivo de Ambiente",
            function: downloadEnvironment,
        },
    ]


    return <ThemeProvider theme={theme}>
        <GlobalStyles styles={{
          body: { margin: 0, padding: 0 },
          '#redoc, .redoc-wrap': { margin: 0 },
        }} />
        <AppBar position="fixed" sx={{}}>
            <Grid container alignItems="center" justifyContent="space-between">
                <Grid item sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Button
                        color="white"
                        variant="text"
                        startIcon={<ArrowBackIosNewIcon />}
                        onClick={() => navigate(HOME_PAGE)}
                        aria-label="Voltar para a página anterior"
                    >
                        Voltar
                    </Button>
                    <img src="/logo/c2p-logo.webp" alt="C2P" style={{ height: 28 }} />
                </Grid>
                <Grid item>
                    <MoreVertButton
                        options={options}
                        item=""
                        icon={
                            <Button
                                variant="outlined"
                                color="white"
                                endIcon={<KeyboardArrowDownIcon/>}
                                aria-haspopup="menu"
                                aria-controls="api-download-menu"
                            >
                                Download da API (Postman + Config)
                            </Button>
                        }
                    />
                </Grid>
            </Grid>
        </AppBar>

        <Box
          sx={{
            mt: { xs: '52px', sm: '52px' },
            position: 'relative',
            zIndex: 0,
            '& .menu-content': {
              position: 'sticky',
              top: { xs: '56px', sm: '64px' },
            },
            '& .api-content': {
              paddingTop: { xs: '56px', sm: '64px' },
            },
          }}
        >
        <RedocStandalone
            specUrl={`./docs/api-doc.json`}
            options={{
                nativeScrollbars: true,
                scrollYOffset: '.MuiAppBar-root',
                theme: {colors: {primary: {main: '#dd5522'}}},
            }}
        />
        </Box>
    </ThemeProvider>
}

export default ApiPage